import { connect } from 'react-redux';
import {
    getActiveModal, hideModal, MODAL_ACCREDITATION_REQUESTS_REJECT
} from "../../../../reducers/common/activeModal";
import {getTranslation} from "../../../../reducers/common/localization";
import RejectAccreditationRequestModal from "./RejectAccreditationRequestModal";

const mapStateToProps = state => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_ACCREDITATION_REQUESTS_REJECT,
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => {
            dispatch(hideModal());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RejectAccreditationRequestModal);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationModal/rejectAccreditationRequestModal/RejectAccreditationRequestModal.container.js